/** @format */
import MyGoodCause from '@components/user/mygoodcause';

const SetGoodCause = () => {
	return <MyGoodCause></MyGoodCause>;
};

SetGoodCause.Layout = true;
SetGoodCause.requireAuth = true;
export default SetGoodCause;
